
angular
	.module('servicepro.gettext', []);


